<template>
  <div class="prenumerate">
    <div class="row end-md">
      <div
        class="col-xs-12 flex end-xs middle-xs"
        :class="{ 'between-xs' : bookPublicationForm }"
      >
        <div class="bookPublicationFormImage" v-show="bookPublicationForm">
          <img :src="'/assets/product-tabs/' + publicationFromPretier + '.svg'" height="70" alt="Oficjalny sklep wydawnictwa Burda Media Polska">
        </div>
        <h4 v-show="bookPublicationForm" class="fs16 m0 capitalize mr-auto align-left">
          {{ bookPublicationForm }}
        </h4>
        <div class="flex wrap end-xs price-box middle-xs">
          <div
            class="flex bottom-xs wrap special-price end-sm mb10"
            v-show="bookPublicationForm && saleDifference"
          >
            <div
              class="h3 lh20 weight-700 word-nowrap"
              :class="{ 'cl-burnt-sienna' : omnibusPrice && saleDifference }"
            >
              {{ price.default | price }}
              <small class="h4">/ {{ $t('piece') }}</small>
              <span v-show="omnibusPrice && saleDifference" class="price-original cl-light-gray weight-500 h5 pl10">
                {{ omnibusPrice | price(storeView) }}
              </span>
            </div>
            <div class="h5 pt5 cl-burnt-sienna w-100">
              {{ saleDifference }}
            </div>
          </div>
          <div class="h3 cl-black weight-500" v-show="bookPublicationForm && !saleDifference">
            {{ price.default | price }}
            <small class="h5">/ {{ $t('piece') }}</small>
          </div>
          <add-to-cart
            :product="product"
            :text="buttonText"
            :class="[disabled ? 'disabled' : '', { 'mw180' : bookPublicationForm }]"
            class="add-to-cart w-100 fs-medium-small"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddToCart from 'theme/components/core/AddToCart.vue'
import ProductPrice from 'theme/mixins/productPrice.ts'
import { getBundleOptionsValues, getBundleOptionsPrices, getBundleOptionsMinPrices } from '@vue-storefront/core/modules/catalog/helpers/bundleOptions'
import { round } from 'mathjs'
import get from 'lodash-es/get'
import { isSpecialPriceActive } from '@vue-storefront/core/modules/catalog/helpers/taxCalc'

export default {
  components: {
    AddToCart
  },
  mixins: [ProductPrice],
  props: {
    bookPublicationForm: {
      type: [String, null],
      default: null
    },
    product: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    publicationFromPretier () {
      if (!this.bookPublicationForm) return
      if (this.bookPublicationForm.includes('okładka')) return 'okladkamiekka'
      else if (this.bookPublicationForm === 'audiubook') return 'audiubook'
      else if (this.bookPublicationForm === 'ebook') return 'ebook'
      else return this.bookPublicationForm
    },
    bundleOptionsPrices () { // current selected option prices
      const allBundeOptions = this.product.bundle_options || []
      const selectedBundleOptions = Object.values(get(this.product, 'product_option.extension_attributes.bundle_options', {}))
      const bundleOptionsValues = getBundleOptionsValues(selectedBundleOptions, allBundeOptions)
      return getBundleOptionsPrices(bundleOptionsValues, this.product.price_type)
    },
    bundleSpecialPrice () { // bundle special price
      const bundleSpecialPrice = this.product.original_special_price / 100 || 0
      return bundleSpecialPrice && isSpecialPriceActive(this.product.special_from_date, this.product.special_to_date)
        ? this.bundleOptionsPrices.map(optionPrice => round(optionPrice * bundleSpecialPrice, 2)).reduce((memo, current) => memo + current, 0)
        : 0
    },
    bundleMinPrice () { // bundle min price
      return this.bundleSpecialMinPrice || getBundleOptionsMinPrices(this.product, this.product.price_type).reduce((memo, current) => memo + current, 0)
    },
    priceToShow () {
      return this.product.promo_price || this.price.default
    },
    buttonText () {
      if (this.bookPublicationForm) return 'Add to cart'
      return this.disabled
        ? 'Zamów od ' + this.$options.filters.price(this.bundleMinPrice)
        : 'Zamów za ' + this.$options.filters.price(this.bundleSpecialPrice || this.priceToShow)
    }
  }
}
</script>

<style lang="scss" scoped>
.prenumerate {
  .bundleOption {
    transition: all 0.2s ease;
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
      filter: grayscale(1);
    }
  }
}
.add-to-cart {
  margin-left: 10px;
  max-width: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  transition: all 0.2s ease;
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
    filter: grayscale(1);
  }
}
.mw180 {
  max-width: 180px;
}
.bookPublicationFormImage {
  background-color: white;
  border-radius: 15px;
  display: flex;
  border: 1.5px solid #CFCFCF;
  margin-right: 10px;
  @media (min-width: 768px) and (max-width: 1125px) {
    display: none;
  }
}
.mr-auto {
  margin-right: auto;
}
.price-box {
  max-width: 70%;
  width: 70%;
  > div.h3 {
    @media (max-width: 1370px) {
      margin-bottom: 10px;
    }
  }
}
.price-original {
  text-decoration: line-through;
}
</style>
